import { useEffect, useState } from "react";
import liveswitch from "fm.liveswitch";
import { Button, Modal } from "react-bulma-components";
import SourceInputDropdown from "./SourceInputDropdown";

type Props = {
    localMedia: liveswitch.LocalMedia;
    show: boolean;
    onClose: () => void;
};

export default function ChannelSettingsModal({
    localMedia,
    show,
    onClose
}: Props) {
    const [videoInputs, setVideoInputs] = useState<liveswitch.SourceInput[]>(
        []
    );
    const [audioInputs, setAudioInputs] = useState<liveswitch.SourceInput[]>(
        []
    );

    useEffect(() => {
        if (!localMedia) {
            return;
        }

        async function getDevices() {
            const videoSourceInputs = await localMedia!.getVideoSourceInputs();
            setVideoInputs(videoSourceInputs);

            const audioSourceInputs = await localMedia!.getAudioSourceInputs();
            setAudioInputs(audioSourceInputs);
        }
        getDevices();
    }, [localMedia]);

    return (
        <Modal show={show} closeOnEsc closeOnBlur onClose={onClose}>
            <Modal.Card>
                <Modal.Card.Header showClose={false}>
                    <Modal.Card.Title>Settings</Modal.Card.Title>
                </Modal.Card.Header>
                <Modal.Card.Body>
                    {videoInputs.length > 0 && (
                        <SourceInputDropdown
                            label="Video Input Source"
                            inputs={videoInputs}
                            defaultValue={videoInputs[0].getId()}
                            onChange={async (input) => {
                                await localMedia?.changeVideoSourceInput(input);
                            }}
                        />
                    )}

                    {audioInputs.length > 0 && (
                        <SourceInputDropdown
                            label="Audio Input Source"
                            inputs={audioInputs}
                            defaultValue={audioInputs[0].getId()}
                            onChange={async (input) => {
                                await localMedia?.changeAudioSourceInput(input);
                            }}
                        />
                    )}
                </Modal.Card.Body>

                <Modal.Card.Footer>
                    <Button rounded onClick={onClose}>Close</Button>
                </Modal.Card.Footer>
            </Modal.Card>
        </Modal>
    );
}
